import Label from 'components/Label'
import React from 'react'
import packageJson from '../../../package.json'
import { StyledPaper as Container } from './styles'

const version = packageJson.version

const Footer: React.FC = () => {
  return (
    <Container square>
      <Label text={`Versão ${version ?? '0.0.0'}`} v='body1' />
    </Container>
  )
}

export default Footer
